<template>
    <div v-show="!$route.meta.noTopHeader">
        <div class="header-fix">
            <base-logo></base-logo>
        </div>
        <div
            v-if="$route.meta.showSideBar"
            class="responsive-sidebar-menu"
            @click="$emit('sidemenu')"
        >
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div
            v-if="menuListing && menuListing.length > 0"
            class="responsive-header-menu"
            @click="mainMain ^= true"
        >
            <img src="@/assets/images/sub-menu.svg" />
        </div>
        <header
            :class="
                (stepStyle == true ? 'step-menu-header' : '',
                mainMain == true ? 'show-menu' : '')
            "
        >
            <div
                class="header-menu navigation"
                :class="stepStyle == true ? 'step-menu' : ''"
            >
                <span class="close-side-bar" @click="mainMain = false"
                    ><i class="icon-delete"></i
                ></span>
                <div
                    v-if="$route.meta.showSideBar == false"
                    class="logo-container"
                >
                    <base-logo anchor-class="colorLogo"></base-logo>
                </div>
                <ul class="menu-list">
                    <li
                        v-for="(list, index) in allowedMenuListing"
                        :key="index"
                        :class="[
                            $route.meta.sessionStep &&
                            $route.meta.sessionStep == list.sessionStep
                                ? 'router-link-exact-active'
                                : '',
                            $route.meta.sessionStep &&
                            $route.meta.sessionStep >= list.sessionStep
                                ? 'router-link-active'
                                : '',
                        ]"
                        @click="mainMain = false"
                    >
                        <router-link
                            :to="setRouterName(list)"
                            :class="[
                                $route.name.toString() === list.name.toString()
                                    ? 'router-link-active router-link-exact-active'
                                    : '',
                                $route.meta.innerTabName ==
                                list.menuLabel.toString()
                                    ? 'router-link-active router-link-exact-active'
                                    : '',
                            ]"
                        >
                            <span v-if="stepStyle" class="point">
                                <i class="icon-check-circle"></i>
                            </span>
                            <span>{{ list.menuLabel }}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div v-if="$route.meta.showSideBar == true" class="profile-block">
                <login-detail> </login-detail>
                <update-profile-popup></update-profile-popup>
                <change-password-popup></change-password-popup>
            </div>
        </header>
    </div>
</template>

<script>
import loginDetail from '@/components/LoginDetail.vue'
import updateProfilePopup from '@/components/popups/UpdateProfilePopup.vue'
import changePasswordPopup from '@/components/popups/ChangePasswordPopup.vue'
import { directive as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    components: {
        loginDetail,
        changePasswordPopup,
        updateProfilePopup,
    },
    directives: {
        onClickOutside: onClickOutside,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        menuListing: {
            type: Array,
            default: null,
        },
        stepStyle: {
            type: Boolean,
            default: false,
        },
        params: {
            type: Object,
            default: undefined,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            mainMain: false,
            image: 'profile-pic.png',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['user', 'scopes']),

        allowedMenuListing() {
            if (this.menuListing) {
                return this.menuListing.filter((item) => {
                    return this.checkPermission(item.permission)
                })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        checkPermission(scopes) {
            if (this.$route.meta.requiresAuth) {
                return !!_.intersection(scopes, this.scopes).length
            }
            return true
        },
        setRouterName(list) {
            // //console.log('Ring')

            if (this.$route.meta.publicRegistration === true) {
                return { name: 'public-registration-' + list.name }
                // return "public-registration-"+list.name
            } else {
                return { name: list.name }
            }
            // return { name: list.name }
        },
    }, // End of Component > mounted
} // End of export default
</script>
